import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import cls from '../styles.module.scss'

export const TextContentSl = () => {
    return (
        <HighlightedText
            text="325% Bonus + 400 BREZPLAČNIH VRTLJAJEV"
            highlights={[{ word: '325%' }, { word: '400' }]}
            breakAfterWords={['Bonus', 'BREZPLAČNIH']}
            className={cls.text}
        />
    )
}
